<template>
    <div>
        <b-list-group>
            <b-list-group-item
                v-for="(persona, personaIdx) in personae"
                :key="personaIdx"
                tag="a"
                :button="false"
                class="text-left"
            >
                <slot name="personaTitle" :persona="persona">
                    <fa-layers class="mr-1">
                        <fa-icon
                            v-for="(icon, iconIdx) in personaIconLookup[persona.role_id]"
                            :key="iconIdx"
                            :class="iconIdx > 0 ? 'text-warning fa-lg' : 'fa-lg'"
                            :transform="iconIdx > 0 ? 'shrink-6 right-3 up-6' : 'left-5'"
                            :icon="icon"
                        />
                    </fa-layers>
                    {{ persona.title }}
                </slot>
                <slot v-if="removable" name="deleteRowButton" :persona="persona">
                    <confirmable-delete-action-button
                        :key="personaIdx"
                        :delete-words="{
                            title: 'Delete Role',
                            button: 'Delete',
                            action: 'Delete',
                            itemType: 'role',
                        }"
                        @deleteRequested="deleteRequested($event)"
                        @deleteConfirmed="deleteConfirmed(persona.id)"
                    />
                </slot>
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<script>
export default {
    props: {
        personae: {
            type: Array,
            default() {
                return [];
            },
        },
        removable: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {};
    },

    computed: {
        personaIconLookup() {
            return {
                RO: ['book-user'],
                AP: ['user', 'university'],

                PR: ['user-tie', 'check'],
                PA: ['user-tie', 'check-double'],
                AM: ['user-tie', 'dollar-sign'],
                BM: ['user-tie', 'sack-dollar'],
                ADMIN: ['user-ninja'],

                SU: ['user-astronaut'],
            };
        },
    },

    methods: {
        deleteRequested($event) {
            this.$emit('deleteRequested', $event);
        },

        deleteConfirmed(rowItemId) {
            this.$emit('deleteConfirmed', rowItemId);
        },

        deleteCancelled($event) {
            this.$emit('deleteCancelled', $event);
        },
    },
};
</script>
